module.exports = __webpack_public_path__ + "img/tuscany-together.a0cb00c3.svg";